<template>
  <v-row class="fill-height pa-0" no-gutters>
    <v-col cols="12">
      <slot />
    </v-col>
  </v-row>
</template>

<script>
export default {}
</script>
